export default "__VITE_ASSET__DFJsUAXe__"